import { render } from "./VideoBig.vue?vue&type=template&id=1c1a820f"
import script from "./VideoBig.vue?vue&type=script&lang=js"
export * from "./VideoBig.vue?vue&type=script&lang=js"

import "./VideoBig.vue?vue&type=style&index=0&id=1c1a820f&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__